
const sidebarMenu = [
    { path: '/admin/dashboard', icon: 'ri-dashboard-line', label: 'Dashboard' },
    // { path: '/admin/home-management', icon: 'ri-home-line', label: 'Quản lý trang chủ' },
    {
      label: 'Quản lý trang chủ',
      icon: 'ri-home-line',
      submenu: [
        { path: '/admin/home-management', label: 'Banner' },
        { path: '/admin/home-management/text-blocks', label: 'Nội dung nổi bật'}
      ]
    },
    // { path: '/admin/about-management', icon: 'ri-information-line', label: 'Quản lý giới thiệu' },
    { 
      
      label: 'Quản lý khách sạn',
      icon: 'ri-hotel-line',
      submenu: [
        { path: '/admin/hotels', label: 'Khách sạn' },
        { path: '/admin/hotels/room-type', label: 'Loại phòng' },
        { path: '/admin/hotels/rooms', label: 'Phòng' }
      ] 
    },
    { 
      label: 'Quản lý tin tức',
      icon: 'ri-newspaper-line',
      submenu: [
        { path: '/admin/news-categories', label: 'Danh mục tin tức' },
        { path: '/admin/news', label: 'Tin tức' }
      ]
    },
    { path: '/admin/contacts', icon: 'ri-contacts-line', label: 'Quản lý liên hệ' },
    { path: '/admin/contact-info', icon: 'ri-contacts-line', label: 'Liên hệ & địa chỉ khách sạn' },
    { path: '/admin/profile', icon: 'ri-user-line', label: 'Tài khoản' }
];

export { sidebarMenu }